import { render, staticRenderFns } from "./StockReset.vue?vue&type=template&id=1b365040&"
import script from "./StockReset.vue?vue&type=script&lang=js&"
export * from "./StockReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports